import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
    import { unref, computed } from 'vue';
    import { RoomProvidersSummary, RoomProvidersSummaryContext } from '@features/roomProviders';
    import { wordEnding } from '@ve/services/textModifiers';
    import SearchPageHotelCardRightBlockPriceToolTip from './components/SearchPageHotelCardRightBlockPriceToolTip.vue';
    import SearchPageHotelCardRightBlockRedirectButton from './components/SearchPageHotelCardRightBlockRedirectButton.vue';
    import { type THotelCardRightBlock } from './types/index';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageHotelCardRightBlock',
  props: {
    hotelCardRightBlockData: null
  },
  emits: ["mouse-over-serp-price-tooltip", "go-to-target-page-button-click"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'mouse-over-serp-price-tooltip'): void;
        (e: 'go-to-target-page-button-click', event: MouseEvent): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { hotelCardRightBlockData: THotelCardRightBlock }

    
    

    const providerOffers = computed(() => props.hotelCardRightBlockData.offers ?? []);

    const adults = computed(() => props.hotelCardRightBlockData.touristGroup.adults);
    const kids = computed(() => props.hotelCardRightBlockData.touristGroup.kids);
    const infants = computed(() => props.hotelCardRightBlockData.touristGroup.infants);
    const checkInDateFormatted = computed(() => moment(props.hotelCardRightBlockData.checkInDate, 'YYYY-MM-DD').format('DD MMMM'));
    const nights = computed(() => props.hotelCardRightBlockData.nights);
    const kidsAndInfantsSum = computed(() => unref(kids) + unref(infants));

    const touristGroupAdultsText = computed(() => `${unref(adults)} взросл${wordEnding(unref(adults), ('ый;ых;ых'))}`);
    const touristGroupKidsText = computed(() => `и ${unref(kidsAndInfantsSum)} ${wordEnding(unref(kidsAndInfantsSum), ('ребенок;детей;детей'))}`);
    const touristGroupInfantsText = computed(() => `и ${unref(infants)} ${wordEnding(unref(infants), ('младенец;младенца;младенца'))}`);
    const dateText = computed(() => `c ${unref(checkInDateFormatted)} на ${unref(nights)} ноч${wordEnding(unref(nights), ('ь;и;ей;'))}`);

return { __sfc: true,props, emit, providerOffers, adults, kids, infants, checkInDateFormatted, nights, kidsAndInfantsSum, touristGroupAdultsText, touristGroupKidsText, touristGroupInfantsText, dateText, RoomProvidersSummary, RoomProvidersSummaryContext, SearchPageHotelCardRightBlockPriceToolTip, SearchPageHotelCardRightBlockRedirectButton }
}

})